import { Download } from '@mui/icons-material';
import React from 'react';

import CButton from './CButton';
import CLocalizedText from './CLocalizedText';

interface CButtonDownloadProps extends Pick<React.ComponentProps<typeof CButton>, 'onClick' | 'isLoading'> {
  url?: string;
  onDownload?: (url: string) => Promise<void> | void;
}

const CButtonDownload = ({ onClick, onDownload, isLoading, url }: CButtonDownloadProps) => {
  const handleAnchorDownload = () => {
    if (!url) return;
    const a = document.createElement('a');
    a.href = url;
    a.download = '';
    document.body.appendChild(a);
    a.click();
    a.remove();
  };

  const handleClick = async (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();

    if (onClick) {
      onClick(e);
      return;
    }

    if (!url) return;

    if (onDownload) {
      await onDownload(url);
      return;
    }

    handleAnchorDownload();
  };

  return (
    <CButton
      icons={{ start: <Download /> }}
      propagateClick={false}
      style={{ borderWidth: 1 }}
      onClick={handleClick}
      isLoading={isLoading}
    >
      <CLocalizedText dictKey={'cButtonDownload.text'} />
    </CButton>
  );
};

export default CButtonDownload;
